import { differenceInCalendarDays, format } from 'date-fns'

// Dates of the News surfaces. The API sends UTC with a trailing Z; `new Date` turns it into the
// reader's local day, which is the one "Today" / "Yesterday" are about.

export const GROUP_TODAY = 'Today'
export const GROUP_WEEK = 'This week'
export const GROUP_EARLIER = 'Earlier'
export const GROUP_ORDER = [GROUP_TODAY, GROUP_WEEK, GROUP_EARLIER]

const toDate = value => (value instanceof Date ? value : new Date(value))

// The exact day, as the rest of the app writes it
export const formatDay = value => (value ? format(toDate(value), 'dd MMM yyyy') : '')

export function formatRelativeDate(value, now = new Date()) {
	if (!value) return ''
	const days = differenceInCalendarDays(now, toDate(value))
	if (days <= 0) return 'Today'
	if (days === 1) return 'Yesterday'
	if (days < 7) return `${days} days ago`
	return formatDay(value)
}

export function relativeDateGroup(value, now = new Date()) {
	const days = differenceInCalendarDays(now, toDate(value))
	if (days <= 0) return GROUP_TODAY
	if (days < 7) return GROUP_WEEK
	return GROUP_EARLIER
}

// History entries arrive newest first, so keeping that order inside each bucket is enough
export function groupByRecency(entries, now = new Date()) {
	const buckets = new Map(GROUP_ORDER.map(name => [name, []]))
	entries.forEach(entry => buckets.get(relativeDateGroup(entry.start_at, now)).push(entry))
	return GROUP_ORDER.map(name => ({ name, items: buckets.get(name) })).filter(group => group.items.length > 0)
}
